/**
 * 阿里云 ESA 图片缩放样式。
 * Key 与主站历史图片样式标识保持一致，只保留 resize 处理。
 */
export const ESA_IMAGE_PROCESSES = {
  '1000x400': 'resize,w_1000',
  '100x100': 'resize,s_100',
  '1200': 'resize,w_1200',
  '1200x460': 'resize,w_1200',
  '1200x800': 'resize,w_1200',
  '150x150': 'resize,s_150',
  '200x200': 'resize,s_200',
  '224x150': 'resize,w_224',
  '300x185': 'resize,w_300',
  '300x300': 'resize,s_300',
  '380x200': 'resize,w_380',
  '380x230': 'resize,w_380',
  '400x153': 'resize,w_400',
  '400x192': 'resize,w_400',
  '400x400': 'resize,s_400',
  '450': 'resize,w_450',
  '650x435': 'resize,w_650',
  '700': 'resize,w_700',
  '72x72': 'resize,s_72',
  '800': 'resize,w_800',
  '900': 'resize,w_900',
  '900x600': 'resize,w_900',
  'avatar': 'resize,s_200',
  'avatar100': 'resize,s_100',
  'banner': 'resize,w_1200',
  'h120': 'resize,h_120'
}

export function esaImageProcess(style) {
  let imageStyle = String(style || '').trim()
  if (!imageStyle) {
    return ''
  }
  if (ESA_IMAGE_PROCESSES[imageStyle]) {
    return ESA_IMAGE_PROCESSES[imageStyle]
  }

  let size = /^(\d+)x(\d+)$/.exec(imageStyle)
  if (size) {
    let width = parseInt(size[1], 10)
    let height = parseInt(size[2], 10)
    if (width < 1 || height < 1) {
      return ''
    }
    return width === height ? `resize,s_${width}` : `resize,w_${width}`
  }

  let widthOnly = /^(\d+)$/.exec(imageStyle)
  if (widthOnly && parseInt(widthOnly[1], 10) > 0) {
    return `resize,w_${parseInt(widthOnly[1], 10)}`
  }

  let heightOnly = /^h(\d+)$/.exec(imageStyle)
  if (heightOnly && parseInt(heightOnly[1], 10) > 0) {
    return `resize,h_${parseInt(heightOnly[1], 10)}`
  }
  return ''
}

/**
 * 在原始图片 URL 上追加 ESA 缩放参数，并保留已有查询参数和锚点。
 */
export function esaImageUrl(url, style) {
  if (!url || !style) {
    return url
  }

  let imageUrl = String(url)
  if (/(?:\?|&)image_process=/.test(imageUrl)) {
    return imageUrl
  }

  let process = esaImageProcess(style)
  if (!process) {
    return imageUrl
  }

  let fragment = ''
  let fragmentPosition = imageUrl.indexOf('#')
  if (fragmentPosition !== -1) {
    fragment = imageUrl.substring(fragmentPosition)
    imageUrl = imageUrl.substring(0, fragmentPosition)
  }

  let separator = imageUrl.indexOf('?') === -1 ? '?' : '&'
  return `${imageUrl}${separator}image_process=${process}${fragment}`
}



// WEBPACK FOOTER //
// ./src/image.js